<template>
  <section class="continue_30">
    <div>
      <img src="@/auto/assets/image/15.png" style="width: 100%" />
    </div>
  </section>
</template>

<script>
export default {
  name: 'Continue',
}
</script>

<style lang="less" scoped>
.continue_30 {
  // height: 1080px;
  width: 100%;
  position: relative;
  background-color: #111;
  overflow: hidden;
}
</style>
